import { SignDocumentTokenCoordinatesGen } from "@/services/sign/v1/data-contracts";

class DocumentTokenCoordinatesBase implements SignDocumentTokenCoordinatesGen {
  x: number;
  y: number;
  h: number;
  w: number;
  fontSize: number;

  constructor(coordinates?: Partial<SignDocumentTokenCoordinatesGen>) {
    this.x = coordinates?.x ?? 0;
    this.y = coordinates?.y ?? 0;
    this.h = coordinates?.h ?? 0;
    this.w = coordinates?.w ?? 0;
    this.fontSize = coordinates?.fontSize ?? 0;
  }
}

type IDocumentTokenCoordinates = DocumentTokenCoordinatesBase;
const DocumentTokenCoordinates = DocumentTokenCoordinatesBase;

export { IDocumentTokenCoordinates, DocumentTokenCoordinates, DocumentTokenCoordinatesBase };
